import login from './login';

export default {
  language: 'pt',
  country: 'br',
  name: 'Português',
  embeddedLocale: login,
};
